/* eslint-disable */
// @ts-nocheck
import React from 'react';
import Viewer from 'viewerjs';
import ReactDOM, { unmountComponentAtNode } from 'react-dom';
import { Tooltip } from 'antd';
import Icon from './icon/Icon';
type IconType = any;
import { debounce, throttle } from './debounce';
import {
  DEFAULT_OPTIONS,
  BTN_ICON_MAP,
  TOOLTIPS_TITLE,
  EXIT_ICON,
  NEXT_ICON,
  CLASS_BACKGROUND,
  PREV_ICON,
  NAMESPACE,
  CLASS_HIDE,
  CLASS_INVISIBLE,
  CLASS_TOOLTIPS,
  CLASS_CLOSE,
  CLASS_FADE,
  CLASS_HEIGHT_OVERSIZE,
  CLASS_WIDTH_OVERSIZE,
  CLASS_MOVE,
  CLASS_FIXED,
  CLASS_TRANSITION,
  CLASS_TRANSITION_FASTER,
  CLASS_LOADING,
  DATA_ACTION,
  LOADING_TITLE,
  TEMPLATE,
  TOOLBAR_CLASS_CONTAINER,
  CLASS_LOADING_TITLE,
  TOOLBAR_CLASS_ITEM_ACTION,
  TOOLBAR_CLASS_ACTION_DISABLED,
  TOOLBAR_DOCS_TEMPLATE,
  CLASS_IMMERSE
} from './constants';
import {
  hasClass,
  setData,
  toggleClass,
  addClass,
  addListener,
  removeClass,
  removeListener,
  isSameFloat,
  dispatchEvent,
  setStyle,
  forEach,
  getTransforms,
  getOffset
} from './utils';
import 'viewerjs/dist/viewer.min.css';
import './customViewerjs.less';

const downloadImage = async (url: string) => {
  const finalUrl = url.replace('https://storage.', 'https://');
  const alink = document.createElement('a');
  alink.href = finalUrl;
  alink.setAttribute('download', 'image');
  alink.setAttribute('target', '_blank');
  alink.setAttribute('rel', 'noreferrer');
  console.log(alink);
  alink.click();
};

const ua = navigator.userAgent;
const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);

/**
 * @description 重写的图片查看器中某些方法
 * Q：为什么重写？
 * A：因为 Viewerjs 的某些实现不符合我们的产品需求，需要我们定制化，但又没提供配置方案。
 * Q：为什么要屏蔽整个文件的 ts 校验？
 * A：因为 Viewerjs 使用 js 写的，且类型文件并没有将内部所有的方法、属性暴露出来，故 ts 无法准确分辨某些方法是否在父类中存在。
 */
class CustomViewer extends Viewer {
  declare viewer: HTMLDivElement;
  declare image: HTMLImageElement;
  declare imageData: object;
  declare canvas: HTMLDivElement; // 图片的 wrapper
  declare button: HTMLDivElement; // 关闭按钮
  declare footer: HTMLDivElement; // 底部区域

  private canDuplicate: boolean;

  constructor(element: HTMLElement, options: Viewer.Options, canDuplicate: boolean) {
    options = { ...DEFAULT_OPTIONS, ...options };
    super(element, options);
    this.canDuplicate = !!canDuplicate;
  }

  /** 上一张图片按钮 */
  private prevBtn: HTMLDivElement | null = null;
  /** 下一张图片按钮 */
  private nextBtn: HTMLDivElement | null = null;
  /** toolbar */
  private toolbar: HTMLDivElement | null = null;
  /** 适应屏幕的 ratio */
  private fullRatio: number | null = null;
  /** 适应屏幕的 imageData */
  private firstImageData: object;
  /** 需要在卸载时 unmount react fiber node 的元素们 */
  private needUnmountEles: HTMLElement[] = [];
  /** 是否沉浸模式 */
  private isImmerse = false;
  /** loading 态的 title */
  private loadingTitle: HTMLDivElement;
  /** 上一次 mouseMoveEvent */
  private lastMouseMoveEvent: PointerEvent;

  // eslint-disable-next-line prettier/prettier
  override zoomTo(ratio: number, hasTooltip?: boolean) {
    hasTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const _zoomable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const _forcePosition =
      arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const shouldCenter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const element = this.element,
      options = this.options,
      imageData = this.imageData;
    const x = imageData.x,
      y = imageData.y,
      width = imageData.width,
      height = imageData.height,
      naturalWidth = imageData.naturalWidth,
      naturalHeight = imageData.naturalHeight;
    ratio = Math.max(0, ratio);

    if (
      typeof ratio === 'number' &&
      this.viewed &&
      !this.played &&
      (_zoomable || options.zoomable)
    ) {
      if (!_zoomable) {
        const minZoomRatio = Math.max(0.01, options.minZoomRatio);
        const maxZoomRatio = Math.min(100, options.maxZoomRatio);
        ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
      }
      // if (_originalEvent && options.zoomRatio >= 0.055 && ratio > 0.95 && ratio < 1.05) {
      //   ratio = 1;
      // }
      const newWidth = naturalWidth * ratio;
      const newHeight = naturalHeight * ratio;
      const offsetWidth = newWidth - width;
      const offsetHeight = newHeight - height;
      const oldRatio = imageData.ratio;

      if (typeof options.zoom === 'function') {
        addListener(element, 'zoom', options.zoom, {
          once: true
        });
      }

      if (
        !dispatchEvent(element, 'zoom', {
          ratio: ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        })
      ) {
        return this;
      }
      this.zooming = true;
      this.updateZoomDisabled(ratio);
      const innerHeight = window.innerHeight;
      const innerWidth = window.innerWidth;
      const widthOverSize = newWidth > innerWidth;
      const heightOverSize = newHeight > innerHeight;

      // 需要以图片中间为中心缩放

      if (_originalEvent) {
        const { pageX, pageY } = _originalEvent;

        // Zoom from the triggering point of the event
        const offset = getOffset(this.viewer);
        imageData.x -= offsetWidth * ((pageX - offset.left - x) / width);
        imageData.y -= offsetHeight * ((pageY - offset.top - y) / height);
      } else {
        // Zoom from the center of the image
        imageData.x -= offsetWidth / 2;
        imageData.y -= offsetHeight / 2;
      }

      // 强制偏移量
      if (_forcePosition) {
        const { x, y } = _forcePosition;
        imageData.x = x;
        imageData.y = y;
      }

      this.adjustLeftAndHeight({
        widthOverSize,
        heightOverSize,
        imageData,
        innerHeight,
        innerWidth,
        newWidth,
        newHeight
      });

      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.oldRatio = oldRatio;
      imageData.ratio = ratio;

      if (shouldCenter) {
        this.centerImageData();
      }

      imageData.left = imageData.x;
      imageData.top = imageData.y;

      this.renderImage(() => {
        this.zooming = false;

        if (typeof options.zoomed === 'function') {
          addListener(element, 'zoomed', options.zoomed, {
            once: true
          });
        }

        dispatchEvent(
          element,
          'zoomed',
          {
            ratio: ratio,
            oldRatio: oldRatio,
            originalEvent: _originalEvent
          },
          {
            cancelable: false
          }
        );

        // 缩放后需要修改拖拽能力
        this.toggleMovableIfNeeded(imageData);
      });

      // if (hasTooltip) {
      //   this.tooltip();
      // }
    }

    return this;
  }

  /** 构建 spin */
  private initLoading = () => {
    const loadingTitle = document.createElement('div');
    loadingTitle.className = CLASS_LOADING_TITLE;
    loadingTitle.innerText = LOADING_TITLE;
    this.loadingTitle = loadingTitle;
  };

  /** 拖拽&点击交互事件 */
  private initDragAndClickAddListener = () => {
    let mousedown = false;
    let mousemoving = false; // 记录拖动状态
    let startPosInImg = false; // 记录开始拖动是否在图片内
    let endPosInImg = false; // 记录结束拖动是否在图片内
    let startClientX;
    let startClientY;
    let timer;
    this.canvas?.addEventListener('pointerdown', e => {
      mousedown = true;
      startPosInImg = e.target.tagName === 'IMG';
      startClientX = e.clientX;
      startClientY = e.clientY;
    });
    this.canvas?.addEventListener('pointerup', e => {
      if (mousedown && (e.clientX !== startClientX || e.clientY !== startClientY)) {
        // 起始位置不一致，则移动了，证明是拖拽
        mousemoving = true;
      }
      mousedown = false;
      endPosInImg = e.target.tagName === 'IMG';
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        // 300ms恢复原状态
        mousemoving = false;
      }, 300);
    });
    this.canvas?.addEventListener('click', e => {
      // 触发了拖拽 且 拖拽起始位置均在图片外，则不关闭预览
      if (mousemoving && (endPosInImg || startPosInImg)) {
        e.preventDefault();
        return;
      }
      // 点击图片或者蒙层或者拖拽只在蒙层区域-触发关闭
      this.hide();
    });
  };

  override build() {
    if (this.ready) {
      return;
    }

    const { element, options } = this;
    const parent = element.parentNode;
    const template = document.createElement('div');

    template.innerHTML = TEMPLATE;

    const viewer = template.querySelector(`.${NAMESPACE}-container`);
    const title = viewer.querySelector(`.${NAMESPACE}-title`);
    const toolbar = viewer.querySelector(`.${NAMESPACE}-toolbar`);
    const navbar = viewer.querySelector(`.${NAMESPACE}-navbar`);
    const button = viewer.querySelector(`.${NAMESPACE}-button`);
    const canvas = viewer.querySelector(`.${NAMESPACE}-canvas`);

    this.parent = parent;
    this.viewer = viewer;
    this.title = title;
    this.toolbar = toolbar;
    this.navbar = navbar;
    this.button = button;
    this.canvas = canvas;
    this.footer = viewer.querySelector(`.${NAMESPACE}-footer`);
    this.tooltipBox = viewer.querySelector(`.${NAMESPACE}-tooltip`);
    this.player = viewer.querySelector(`.${NAMESPACE}-player`);
    this.list = viewer.querySelector(`.${NAMESPACE}-list`);

    viewer.id = `${NAMESPACE}${this.id}`;

    addClass(title, CLASS_HIDE); // 隐藏 标题
    addClass(navbar, CLASS_HIDE); // 隐藏 navbar

    if (options.keyboard) {
      button.setAttribute('tabindex', 0);
    }
    this.initDragAndClickAddListener();
    // setData(DATA_ACTION, 'hide', canvas); // 点击背景触发关闭 修改为move交互
    // let lastMouseDown = 0;
    // canvas?.addEventListener('click', e => {
    //   // 点击图片也触发关闭
    //   if (e.target.tagName === 'IMG') {
    //     const delay = Date.now() - lastMouseDown;
    //     if (delay < 300) this.hide();
    //   }
    // });
    // canvas?.addEventListener(
    //   'pointerdown',
    //   e => {
    //     // 按住拖动也会触发 click，因此区别一下
    //     lastMouseDown = Date.now();
    //   },
    //   true
    // );
    this.initLoading(); // 初始化 loading
    this.initToolbar(); // 重写 toolbar
    this.initBackground(); // 初始化背景

    addClass(button, CLASS_CLOSE);
    addClass(viewer, CLASS_FIXED);
    addClass(viewer, CLASS_FADE);
    addClass(viewer, CLASS_HIDE);

    viewer.style.zIndex = options.zIndex;

    let { container } = options;

    if (typeof container === 'string') {
      container = element.ownerDocument.querySelector(container);
    }

    if (!container) {
      container = this.body;
    }

    container.appendChild(viewer);

    this.ready = true;

    this.initPrevNextBtn(); // 前进后退按钮
    this.initClickBtn(button);
    this.bindEvent(); // 绑定事件

    if (typeof options.ready === 'function') {
      addListener(element, 'ready', options.ready, {
        once: true
      });
    }

    if (dispatchEvent(element, 'ready') === false) {
      this.ready = false;
      return;
    }
    this.doLog('view');
  }

  override hide(...args) {
    this.doLog(args[1] ? 'close' : 'close-blank');
    addClass(this.image, CLASS_TRANSITION_FASTER);
    setTimeout(() => {
      super.hide(...args);
    }, 0);
  }

  override moveTo(x, y = x, _originalEvent = null) {
    const { element, options, imageData } = this;

    x = Number(x);
    y = Number(y);

    if (this.viewed && !this.played && options.movable) {
      const oldX = imageData.x;
      const oldY = imageData.y;
      let changed = false;

      if (typeof x === 'number') {
        changed = true;
        x = this.getMoveDistance(x, true, oldX);
      } else {
        x = oldX;
      }

      if (typeof y === 'number') {
        changed = true;
        y = this.getMoveDistance(y, false, oldY);
      } else {
        y = oldY;
      }

      if (changed) {
        if (typeof options.move === 'function') {
          addListener(element, 'move', options.move, {
            once: true
          });
        }

        if (
          dispatchEvent(element, 'move', {
            x,
            y,
            oldX,
            oldY,
            originalEvent: _originalEvent
          }) === false
        ) {
          return this;
        }

        imageData.x = x;
        imageData.y = y;
        imageData.left = x;
        imageData.top = y;
        this.moving = true;
        this.renderImage(() => {
          this.moving = false;

          if (typeof options.movee === 'function') {
            addListener(element, 'moved', options.moved, {
              once: true
            });
          }

          dispatchEvent(
            element,
            'moved',
            {
              x,
              y,
              oldX,
              oldY,
              originalEvent: _originalEvent
            },
            {
              cancelable: false
            }
          );
        });
      }
    }

    return this;
  }

  /** 缩放时校正left 和 top */
  private adjustLeftAndHeight = (opts: {
    widthOverSize: boolean;
    heightOverSize: boolean;
    imageData: any;
    innerHeight: number;
    innerWidth: number;
    newWidth: number;
    newHeight: number;
  }) => {
    const {
      widthOverSize,
      heightOverSize,
      imageData,
      innerHeight,
      innerWidth,
      newHeight,
      newWidth
    } = opts;
    if (widthOverSize && imageData.x > 0) {
      // 宽度超过屏幕， 校正
      imageData.x = 0;
    }
    if (heightOverSize && imageData.y > 0) {
      // 高度超过屏幕，校正
      imageData.y = 0;
    }
    if (heightOverSize && imageData.y < innerHeight - newHeight) {
      // 高度超过屏幕，校正
      imageData.y = innerHeight - newHeight;
    }
    if (widthOverSize && imageData.x < innerWidth - newWidth) {
      // 宽度超过屏幕，校正
      imageData.x = innerWidth - newWidth;
    }
    this.adjustPadding(widthOverSize, heightOverSize);
  };

  /** 修改 padding */
  private adjustPadding = (widthOverSize: boolean, heightOverSize: boolean) => {
    const isHeightOverSizeInClass = this.image.classList.contains(CLASS_HEIGHT_OVERSIZE);
    const isWidthOverSizeInClass = this.image.classList.contains(CLASS_WIDTH_OVERSIZE);
    if (widthOverSize && !isWidthOverSizeInClass) {
      this.image.classList.add(CLASS_WIDTH_OVERSIZE);
    }
    if (!widthOverSize && isWidthOverSizeInClass) {
      this.image.classList.remove(CLASS_WIDTH_OVERSIZE);
    }
    if (heightOverSize && !isHeightOverSizeInClass) {
      this.image.classList.add(CLASS_HEIGHT_OVERSIZE);
    }
    if (!heightOverSize && isHeightOverSizeInClass) {
      this.image.classList.remove(CLASS_HEIGHT_OVERSIZE);
    }
  };

  /** 改变缩放按钮禁用状态 */
  private updateZoomDisabled = (ratio: number) => {
    const zoomOutBtn = this.toolbar?.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-zoom-out`);
    const zoomInBtn = this.toolbar?.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-zoom-in`);
    if (4 === ratio) {
      // 不可继续放大
      !zoomInBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        zoomInBtn?.classList.add(TOOLBAR_CLASS_ACTION_DISABLED);
    } else {
      // 可以继续放大
      zoomInBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        zoomInBtn?.classList.remove(TOOLBAR_CLASS_ACTION_DISABLED);
    }
    if (0.1 === ratio) {
      // 不可继续缩小
      !zoomOutBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        zoomOutBtn?.classList.add(TOOLBAR_CLASS_ACTION_DISABLED);
    } else {
      zoomOutBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        zoomOutBtn?.classList.remove(TOOLBAR_CLASS_ACTION_DISABLED);
    }
  };

  /** 改变适应屏幕和展示原图的禁用状态 */
  private updateAdaptDisabled = (ratio: number) => {
    const fullScreenBtn = this.toolbar?.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-full-screen`);
    const initialSizeBtn = this.toolbar?.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-initial-size`);
    if (isSameFloat(1, ratio)) {
      // 展示原尺寸不可用
      !initialSizeBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        initialSizeBtn?.classList.add(TOOLBAR_CLASS_ACTION_DISABLED);
    } else {
      // 展示原尺寸可用
      initialSizeBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        initialSizeBtn?.classList.remove(TOOLBAR_CLASS_ACTION_DISABLED);
    }
    if (isSameFloat(this.fullRatio, ratio)) {
      // 适应屏幕不可用
      !fullScreenBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        fullScreenBtn?.classList.add(TOOLBAR_CLASS_ACTION_DISABLED);
    } else {
      // 适应屏幕可用
      fullScreenBtn?.classList.contains(TOOLBAR_CLASS_ACTION_DISABLED) &&
        fullScreenBtn?.classList.remove(TOOLBAR_CLASS_ACTION_DISABLED);
    }
  };

  /** 判断是否可以继续移动图片 */
  private getMoveDistance = (val: number, isHor: boolean, oldVal: number) => {
    const {
      imageData: { width, height }
    } = this;
    const innerHeight = window.innerHeight;
    const innerWidth = window.innerWidth;
    // 宽度没有超过视口，不让移动
    if (isHor && width < innerWidth) {
      return oldVal;
    }
    // 高度没有超过视口，不让移动
    if (!isHor && height < innerHeight) {
      return oldVal;
    }

    const isDownOrRight = val < oldVal; // 新值比旧值大说明是向左或向上
    if (isDownOrRight) {
      // 向下或向右时
      if (!isHor ? val < innerHeight - height : val < innerWidth - width) {
        return !isHor ? innerHeight - height : innerWidth - width;
      }
    } else {
      // 向上或向左时
      if (val > 0) {
        // 移动后，图片边缘超出
        return 0;
      }
    }
    return val;
  };

  /** 改变可拖拽状态 */
  private toggleMovableIfNeeded = imageData => {
    if (imageData.height > window.innerHeight || imageData.width > window.innerWidth) {
      this.options.movable = true;
      this.image?.classList.add(`${NAMESPACE}-move`);
    } else {
      this.options.movable = false;
      this.image?.classList.remove(`${NAMESPACE}-move`);
    }
  };

  /** 初始化关闭按钮 */
  private initClickBtn = (btn: HTMLElement) => {
    btn.innerHTML = '';
    this.useReactTooltips(btn, {
      title: TOOLTIPS_TITLE['exit'],
      iconType: EXIT_ICON,
      offset: [0, 10],
      placement: 'bottom'
    });
  };

  /** 组织自己的 toolbar */
  private initToolbar = () => {
    addClass(this.toolbar, 'vodka-viewer-toolbar');
    this.toolbar.innerHTML = TOOLBAR_DOCS_TEMPLATE;
    this.initTooltips();
    this.initPageNumber();
    this.initBtn();
  };

  /** 初始化背景 */
  private initBackground = () => {
    const background = document.createElement('div');
    background.className = CLASS_BACKGROUND;
    background.style.backgroundColor = '#1f2329';
    background.style.opacity = '0.8';
    background.style.height = '100%';
    background.style.width = '100%';
    background.appendChild(this.loadingTitle); // loading 的 title 放这里
    this.viewer.prepend(background);
  };

  /** 初始化页码 */
  private initPageNumber = () => {
    const pageNumber = this.toolbar.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-list`);
    this.toolbarPageNumber = pageNumber;
  };

  /** 初始化 toolbar 按钮事件 */
  private initBtn = () => {
    const actions = this.toolbar.querySelectorAll(`.${TOOLBAR_CLASS_ITEM_ACTION}`);
    for (let i = 0; i < actions.length; i++) {
      const action = actions[i];
      const name = action.getAttribute('data-action');
      if (name) {
        this.useReactTooltips(action, {
          title: TOOLTIPS_TITLE[name],
          iconType: BTN_ICON_MAP[name],
          offset: [0, -10]
        });

        if (name === 'download' && !this.canDuplicate) {
          // 没有下载权限，不让下载
          action?.classList.add(TOOLBAR_CLASS_ACTION_DISABLED);
          continue;
        }
        setData(DATA_ACTION, name, action?.firstElementChild);
        setData(DATA_ACTION, name, action?.firstElementChild?.firstElementChild);
        setData(DATA_ACTION, name, action?.firstElementChild?.firstElementChild?.firstElementChild);
      }

      this.bindTollbarBtnEvent(action, name);
    }
  };

  /** 为内部没有定义的按钮增加事件 */
  private bindTollbarBtnEvent = (action: HTMLElement, name: string) => {
    addListener(action?.firstElementChild, 'click', e => {
      switch (name) {
        case 'initial-size':
          this.doLog(name);
          this.zoomTo(1, true, undefined, undefined, undefined, true);
          break;
        case 'full-screen':
          this.doLog(name);
          this.zoomTo(this.fullRatio || 1, true, undefined, undefined, this.firstImageData);
          // this.moveTo(this.firstImageData.x, this.firstImageData.y)
          break;
        case 'zoom-in':
          this.doLog(name);
          break;
        case 'zoom-out':
          this.doLog(name);
          break;
        case 'rotate-left':
          this.doLog(name);
          break;
        case 'download':
          this.doLog('download');
          this.download();
          break;
        default:
          break;
      }
    });
  };

  /** 图片居中 */
  private centerImageData = () => {
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    const imageWidth = this.imageData.width;
    const imageHeight = this.imageData.height;
    this.imageData.x = (innerWidth - imageWidth) / 2;
    this.imageData.y = (innerHeight - imageHeight) / 2;
  };

  /** 下载 */
  private download = async () => {
    downloadImage(this.image.src);
  };

  /** 改变 tooltips 位置 */
  private initTooltips = () => {
    const ratio = this.toolbar.querySelector(`.${TOOLBAR_CLASS_CONTAINER}-ratio`);
    this.viewer.removeChild(this.tooltipBox);
    ratio.appendChild(this.tooltipBox);
  };

  /** 组织前进后退按钮 */
  private initPrevNextBtn = () => {
    const nextBtn = document.createElement('div');
    const prevBtn = document.createElement('div');
    addClass(nextBtn, 'vodka-viewer-next');
    addClass(prevBtn, 'vodka-viewer-prev');
    this.nextBtn = nextBtn;
    this.prevBtn = prevBtn;
    this.updateNextPrevVisible(this.images.length, this.index);
    this.viewer.appendChild(nextBtn);
    this.viewer.appendChild(prevBtn);
    this.useReactTooltips(this.nextBtn, {
      title: TOOLTIPS_TITLE['next'],
      iconType: NEXT_ICON,
      offset: [0, -10]
    });

    this.useReactTooltips(this.prevBtn, {
      title: TOOLTIPS_TITLE['prev'],
      iconType: PREV_ICON,
      offset: [0, -10]
    });
  };

  /** react 渲染 */
  private useReactTooltips = (
    element: HTMLElement,
    opts: {
      title: string;
      iconType: IconType;
      iconStyle?: object;
      offset?: [number, number];
      placement?: StaticRange;
    }
  ) => {
    const { title, iconType, iconStyle = {}, offset = [0, 0], placement = 'top' } = opts;
    let overlayClassName = CLASS_TOOLTIPS;
    if (iconType === NEXT_ICON) {
      overlayClassName += ' next-btn';
    }
    if (iconType === PREV_ICON) {
      overlayClassName += ' prev-btn';
    }
    ReactDOM.render(
      <Tooltip
        title={title}
        overlayClassName={overlayClassName}
        getPopupContainer={() => this.viewer}
        placement={placement}
        align={{
          offset
        }}
      >
        <Icon
          style={{
            fontSize: '24px',
            cursor: 'pointer',
            ...iconStyle
          }}
          color='Gray01'
          icon={iconType}
        />
      </Tooltip>,
      element
    );

    this.needUnmountEles.push(element);
  };

  /** 更新比例数值 */
  private updateRatio = (ratio: number) => {
    const value = (ratio * 100).toFixed(0);
    this.tooltipBox.innerHTML = `${value}%`;

    // this.tooltipBox.innerHTML = `<input style='width: 30px;border:none; line-height:1; background-color: transparent' value='${value}'>%`;
    // const element = this.tooltipBox.children[0];
    // element.addEventListener('blur', ()=>{
    //   const value = this.getValidRatio(element.value)
    //   const toZoom = value / 100
    //   this.zoomTo(toZoom, true)
    // })
  };

  /** 输入 */
  private getValidRatio = (inputValue: string) => {
    if (isNaN(inputValue) || inputValue < 10 || inputValue > 400) return 100;
    return inputValue;
  };

  /** 更新页码 */
  private updatePageNumber = (length: number, index: number) => {
    this.toolbarPageNumber.innerHTML = `<span>${index + 1}/${length}</span>`;
    this.updateNextPrevVisible(length, index);
  };

  /** 更新 next 和 prev 的显示隐藏 */
  private updateNextPrevVisible = (length: number, index: number) => {
    const isPrevVisible =
      this.prevBtn.style.visibility === '' || this.prevBtn.style.visibility === 'visible';
    const isNextVisible =
      this.nextBtn.style.visibility === '' || this.nextBtn.style.visibility === 'visible';
    const prevTooltip = this.viewer.querySelector('.prev-btn');
    const nextTolltip = this.viewer.querySelector('.next-btn');
    if (0 === index) {
      // 第一张图，prev 不显示
      this.prevBtn.style.visibility = 'hidden';
      if (prevTooltip) {
        prevTooltip.style.visibility = 'hidden';
      }
    }
    if (length === index + 1) {
      // 最后一张图，next 不显示
      this.nextBtn.style.visibility = 'hidden';
      if (nextTolltip) {
        nextTolltip.style.visibility = 'hidden';
      }
    }
    if (0 !== index) {
      // 都显示
      if (!isPrevVisible) {
        this.prevBtn.style.visibility = 'visible';
        if (prevTooltip) {
          prevTooltip.style.visibility = 'visible';
        }
      }
    }
    if (length !== index + 1) {
      if (!isNextVisible) {
        this.nextBtn.style.visibility = 'visible';
        if (nextTolltip) {
          nextTolltip.style.visibility = 'visible';
        }
      }
    }
  };

  /** 绑定事件 */
  private bindEvent = () => {
    if (!this.viewer) return;
    this.bindMetaDown();
    this.bindWheel();
    this.bindNextPrev();
    this.bindExitBtn();
    this.bindKeyEvent();
    this.bindMouseMove();
    this.bindFooterClick();
  };

  /** 绑定底部点击事件 */
  private bindFooterClick = () => {
    addListener(this.footer, 'click', this.handleFooterClick);
  };

  /** 点击底部也退出图片查看 */
  private handleFooterClick = (e: PointerEvent) => {
    const path = e['path'] || (e['composedPath'] && e['composedPath']()) || [];
    if (path.length) {
      let clickToolbar = false;
      for (let i = 0; i < path.length; i++) {
        if (path[i].classList && path[i].classList.contains(TOOLBAR_CLASS_CONTAINER)) {
          clickToolbar = true;
          break;
        }
      }
      !clickToolbar && this.hide();
    }
  };

  /** 绑定鼠标移动 */
  private bindMouseMove = () => {
    addListener(this.viewer, 'mousemove', throttle(this.handleMouseMove, 100));
  };

  /** 鼠标移动 */
  private handleMouseMove = (e: PointerEvent) => {
    if (
      this.lastMouseMoveEvent &&
      this.lastMouseMoveEvent.pageX === e.pageX &&
      this.lastMouseMoveEvent.pageY === e.pageY
    ) {
      return; // safari 下会再触发一次 mousemove ，兼容下
    }
    this.lastMouseMoveEvent = e;
    this.immerseByDebounce();
    this.unImmerse();
  };

  /** 处理键盘事件 */
  private handleKeyDown = (e: KeyboardEvent) => {
    switch (e.key) {
      case '=':
      case '-':
        if (e.metaKey || e.ctrlKey) {
          e.preventDefault();
          this.zoom(e.key === '=' ? 0.1 : -0.1, true);
        }
        break;
      case 'ArrowUp':
        this.doLog('up');
        break;
      case 'ArrowDown':
        this.doLog('down');
        break;
      case 'ArrowLeft':
        this.doLog('left');
        break;
      case 'ArrowRight':
        this.doLog('right');
        break;
      case 'Escape':
        this.doLog('esc');
        // FIX: safari浏览器全屏预览图片点击esc退出预览，浏览器也会退出全屏
        e.preventDefault();
        break;
      default:
        break;
    }
  };

  /** 绑定键盘相关事件 */
  private bindKeyEvent = () => {
    addListener(this.viewer, 'keydown', this.handleKeyDown);
  };

  /** 绑定关闭按钮 */
  private bindExitBtn = () => {
    addListener(this.button, 'click', () => {
      this.hide(false, true); // params: immediate，triggerByButton
    });
  };

  /** 绑定上一页下一页 */
  private bindNextPrev = () => {
    addListener(this.nextBtn, 'click', () => {
      this.doLog('next');
      this.next();
    });
    addListener(this.prevBtn, 'click', () => {
      this.doLog('prev');
      this.prev();
    });
  };

  // 记录哪些只 log 一次的 action
  private doLogOnceMap: any = {};

  // /** 埋点 */
  private doLog = (action: string, once?: boolean) => {
    if (once && this.doLogOnceMap[action]) return;
    this.doLogOnceMap[action] = true;
  };

  /** 检测是否正在wheel */
  private checkAndSetWheeling = event => {
    if (!this.viewed) {
      return false;
    }
    event.stopPropagation();
    event.preventDefault();
    if (this.wheeling) {
      return false;
    }

    this.wheeling = true;

    setTimeout(() => {
      this.wheeling = false;
    }, 50);
    return true;
  };

  /** 监听 gesturestart，用于禁止页面缩放 */
  private handleGesturestart = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  /** 监听 gesturechange */
  private handleGesturechange = e => {
    if (!this.checkAndSetWheeling(e)) return;
    const ratio = Number(this.options.zoomRatio) || 0.1;
    const scale = e.scale;
    const delta = scale > 1 ? 1 : -1;
    this.zoom(delta * ratio, true, e);
  };

  /** wheel 方法 */
  private handleWheel = event => {
    /** 这里加上 this.isMetaDown，就可以完成二期的 cmd + 鼠标滑轮可缩放需求 */
    if (event.ctrlKey) {
      if (!this.checkAndSetWheeling(event)) return;
      const ratio = Number(this.options.zoomRatio) || 0.1;
      let delta = 1;

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, true, event);
      this.doLog('touchpadzoom', true);
    } else {
      this.wheelMoveByThrottle(event);
    }
  };

  /** 节流的 move */
  private wheelMoveByThrottle = throttle((event: WheelEvent) => {
    // 没按着 metaKey，移动
    const speed = 1;
    if (event.deltaY || event.deltaX) {
      let offsetX = 0;
      let offsetY = 0;
      if (event.deltaX !== 0) {
        offsetX = -(speed * event.deltaX);
      }
      if (event.deltaY !== 0) {
        offsetY = -(speed * event.deltaY);
      }
      this.image?.classList.remove(CLASS_TRANSITION);
      this.move(offsetX, offsetY);
      this.doLog('touchpadslide', true);
      this.addTransitionByDebounce();
    }
  }, 8);

  /** debounce 加 trisition */
  private addTransitionByDebounce = debounce(() => {
    this.image?.classList.add(CLASS_TRANSITION);
  }, 200);

  /** 监听 mousewheel */
  private bindWheel = () => {
    if (isSafari) {
      addListener(this.viewer, 'gesturestart', this.handleGesturestart);
      addListener(this.viewer, 'gesturechange', this.handleGesturechange);
      addListener(this.viewer, 'mousewheel', this.handleWheel, { passive: false });
    } else {
      addListener(this.viewer, 'mousewheel', this.handleWheel, { passive: false });
    }
  };

  /** 解绑 */
  private unbindEvent = () => {
    removeListener(this.viewer, 'keydown', e => {
      if (e.keyCode === 91) {
        this.isMetaDown = true;
      }
    });
    removeListener(this.viewer, 'keyup', e => {
      if (e.keyCode === 91) {
        this.isMetaDown = false;
      }
    });
    if (isSafari) {
      removeListener(this.viewer, 'gesturestart', this.handleGesturestart);
      removeListener(this.viewer, 'gesturechange', this.handleGesturechange);
      removeListener(this.viewer, 'mousewheel', this.handleWheel, { passive: false });
    } else {
      removeListener(this.viewer, 'mousewheel', this.handleWheel, { passive: false });
    }
    removeListener(this.nextBtn, 'click', () => {
      this.next();
    });
    removeListener(this.prevBtn, 'click', () => {
      this.prev();
    });
    removeListener(this.button, 'click', () => {
      this.hide();
    });
    removeListener(this.viewer, 'keypress', this.handleKeyDown);
    removeListener(this.viewer, 'mousemove', this.handleMouseMove);
    removeListener(this.footer, 'click', this.handleFooterClick);
  };

  /** 监听是否按下 meta 键 */
  private bindMetaDown = () => {
    addListener(this.viewer, 'keydown', e => {
      if (e.keyCode === 91) {
        this.isMetaDown = true;
      }
    });
    addListener(this.viewer, 'keyup', e => {
      if (e.keyCode === 91) {
        this.isMetaDown = false;
      }
    });
  };

  /** 设置适应屏幕的 ratio */
  private updateFullScreenRatioIfNeeded = () => {
    const { image, imageData } = this;
    const isFirst = image.style.height === '0px'; // 图片未加载完成时，高度为0，hack一下初次加载
    if (isFirst) {
      this.fullRatio = imageData.ratio;
      this.firstImageData = JSON.parse(JSON.stringify(imageData));
    }
  };

  /** 激活 loading */
  private setLoadingInvisible = () => {
    this.loadingTitle.style.display = 'none';
  };

  override load() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }

    const { element, options, image, index, viewerData } = this;

    removeClass(image, CLASS_INVISIBLE);
    // 产品要求打开和关闭时，不需要动画
    addClass(image, CLASS_TRANSITION_FASTER);
    const imgTypeClassName = this.images[index].getAttribute('data-img-type');
    const defaultImgRotation = this.images[index].getAttribute('data-default-rotation');
    addClass(image, imgTypeClassName);

    if (options.loading) {
      removeClass(this.canvas, CLASS_LOADING);
      this.setLoadingInvisible();
    }

    image.style.cssText =
      'height:0;' +
      `margin-left:${viewerData.width / 2}px;` +
      `margin-top:${viewerData.height / 2}px;` +
      'max-width:none!important;' +
      'position:relative;' +
      'width:0;';

    this.initImage(() => {
      toggleClass(image, CLASS_MOVE, options.movable);
      toggleClass(image, CLASS_TRANSITION, options.transition);

      if (defaultImgRotation) {
        this.imageData.rotate = Number(defaultImgRotation);
      }

      this.renderImage(() => {
        this.viewed = true;
        this.viewing = false;

        if (typeof options.viewed === 'function') {
          addListener(element, 'viewed', options.viewed, {
            once: true
          });
        }

        dispatchEvent(
          element,
          'viewed',
          {
            originalImage: this.images[index],
            index,
            image
          },
          {
            cancelable: false
          }
        );

        removeClass(image, CLASS_TRANSITION_FASTER);
      });
    });
  }

  override initList = () => {
    const { element, options, list } = this;
    const items = [];
    list.innerHTML = '';

    forEach(this.images, (image, index) => {
      const { src } = image;
      const url = this.getImageURL(image);

      if (src || url) {
        const item = document.createElement('li');
        const img = document.createElement('img');

        forEach(options.inheritedAttributes, name => {
          const value = image.getAttribute(name);

          if (value !== null) {
            img.setAttribute(name, value);
          }
        });

        // img.src = src || url;
        img.setAttribute('data-original-url', url || src);
        item.setAttribute('data-index', index);
        item.setAttribute('data-viewer-action', 'view');
        item.setAttribute('role', 'button');

        if (options.keyboard) {
          item.setAttribute('tabindex', 0);
        }

        item.appendChild(img);
        list.appendChild(item);
        items.push(item);
      }
    });

    this.items = items;

    forEach(items, item => {
      const image = item.firstElementChild;
      let onLoad;
      let onError;

      // setData(image, 'filled', true);

      if (options.loading) {
        addClass(item, CLASS_LOADING);
      }

      addListener(
        image,
        'load',
        (onLoad = event => {
          removeListener(image, 'error', onError);

          if (options.loading) {
            removeClass(item, CLASS_LOADING);
          }

          this.loadImage(event);
        }),
        {
          once: true
        }
      );

      addListener(
        image,
        'error',
        (onError = () => {
          removeListener(image, 'load', onLoad);

          if (options.loading) {
            removeClass(item, CLASS_LOADING);
          }
        }),
        {
          once: true
        }
      );
    });

    if (options.transition) {
      addListener(
        element,
        'viewed',
        () => {
          addClass(list, CLASS_TRANSITION);
        },
        {
          once: true
        }
      );
    }
  };

  override renderImage = (done: () => void) => {
    const { image, imageData } = this;
    this.updateFullScreenRatioIfNeeded();
    this.updateRatio(imageData.ratio);
    this.updatePageNumber(this.images.length, this.index);
    setStyle(
      image,
      Object.assign(
        {
          width: imageData.width,
          height: imageData.height,
          marginLeft: imageData.x,
          marginTop: imageData.y
        },
        getTransforms(imageData)
      )
    );
    this.updateAdaptDisabled(imageData.ratio);

    if (done) {
      if (
        (this.viewing || this.moving || this.rotating || this.scaling || this.zooming) &&
        this.options.transition &&
        hasClass(image, CLASS_TRANSITION)
      ) {
        const onTransitionEnd = () => {
          this.imageRendering = false;
          done();
        };

        this.imageRendering = {
          abort: () => {
            removeListener(image, 'transitionend', onTransitionEnd);
          }
        };

        addListener(image, 'transitionend', onTransitionEnd, {
          once: true
        });
      } else {
        done();
      }
    }
    this.unImmerse();
    this.immerseByDebounce();
  };

  /** 进入沉浸模式 */
  private immerseByDebounce = debounce(() => {
    if (this.isImmerse) {
      return;
    }
    this.isImmerse = true;
    this.viewer?.classList.add(CLASS_IMMERSE);
  }, 3000);

  /** 退出沉浸模式 */
  private unImmerse = () => {
    if (!this.isImmerse) {
      return;
    }
    this.isImmerse = false;
    this.viewer?.classList.remove(CLASS_IMMERSE);
  };

  /** 卸载所有 react fiber node */
  private unmountAllFiberNode = () => {
    for (let i = 0; i < this.needUnmountEles.length; i++) {
      const ele = this.needUnmountEles[i];
      unmountComponentAtNode(ele);
    }
    this.needUnmountEles.length = 0;
  };

  override destroy = () => {
    const { element, options } = this;

    if (!element[NAMESPACE]) {
      return this;
    }

    this.destroyed = true;

    this.unbindEvent();
    this.unmountAllFiberNode();
    if (this.ready) {
      if (this.played) {
        this.stop();
      }

      if (this.isShown) {
        if (this.viewing) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        }

        if (this.hiding) {
          this.transitioning.abort();
        }

        this.hidden();
      } else if (this.showing) {
        this.transitioning.abort();
        this.hidden();
      }

      this.ready = false;
      this.viewer.parentNode.removeChild(this.viewer);
    }
    removeListener(element, 'click', this.onStart);
    element[NAMESPACE] = undefined;
    return this;
  };
  override view(index) {
    super.view(index);
    //ViewerJS这个库内部使用setTimeout进行了兜底，当图片1s没有加载成功时，会展示未完全加载的图片
    // 这个行为会导致如果图片请求时间超过一秒会出现抖动的现象
    // 目前这个兜底方案不可取消或配置，这里先用取消this.timeout的方式来解决这个问题
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }
  }
}

export default CustomViewer;
